/**
 * author: Soumya Shreyas
 */
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import {
  Badge,
  Breadcrumb,
  Form,
  OverlayTrigger,
  Table
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import {
  BiSearch,
  BiSend,
  BiSort
} from "react-icons/bi";
import { FcFinePrint } from "react-icons/fc";
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { CompanyContext, RegulationContext } from "../../../../App";
import Pagination from "../../../../components/Pagination/Pagination";
import ReportingPeriod from "../../../../components/Regulation/ReportingPeriod";
import {
  DEFAULT_ITEMS_PER_PAGE,
  FORM_BUILDER_LISTING_URL,
  LIST_DEF_SORT,
  SORT_ORDER_DESC,
  STATUS,
} from "../../../../core/constants/common";
import FormService from "../../../../core/service/FormService";
import Utils from "../../../../core/utilities/Utils";
import "../Forms.scss";

function FormSubmitted({ t }) {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [searchKey, setSearchKey] = useState("");
  const [forms, setForms] = useState([]);
  const { glbRegulation, setGlbRegulation } = useContext(RegulationContext);
  const glbRegulationId = glbRegulation?.id ? glbRegulation.id : "";
  const month = Utils.getMonthFromFrequency(glbRegulation.frequency);
  const year = new Date().getFullYear();
  const activeReportingPeriod = searchParams.get('period') 
    ? searchParams.get('period')
    : `${year}-${month}-01`;
  const [reportingPeriod, setReportingPeriod] = useState(activeReportingPeriod);
  const location = useLocation();
  const formId = searchParams.get('fid') 
    ? (searchParams.get('fid')) 
    : (location?.state && location.state.id);
  const regulationName = location.state && location.state.regulationName;
  const [formName, setFormName] = useState(location.state && location.state.name);
  const eId = location.state && location.state.eId;
  const sId = location.state && location.state.sId;
  let data = JSON.parse(localStorage.getItem("authority"));
  const supplierId = data.profile.company.id;
  const { glbCompany } = useContext(CompanyContext);

  var authToken = localStorage.getItem("accessToken");
  const currentRoute = window.location.pathname;

  useEffect(() => {
    formId && getForms(0, itemsPerPage, searchKey, sortField);
  }, [glbRegulationId, reportingPeriod]);

  const getForms = (pageNumber, itemsPerPageVal, searchVal = "", sortField) => {
    var perPage = '';
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      perPage = itemsPerPageVal;
    } else {
      perPage = itemsPerPage;
    }
    var sort = sortField + "," + order;

    if (!data.roles.includes("SUPPLIER_ADMIN")) return;

    fetchForm();
    FormService.listSubmittedAssessmentForms(
      pageNumber,
      perPage,
      searchVal,
      formId,
      reportingPeriod,
      sort,
      false,
      supplierId,
      0,
      glbCompany?.companyId ?? 0
    ).then((response) => {
      const totalPages = parseFloat(response.headers["x-total-count"]);
      setItemTotalCount(totalPages);
      setForms([...response.data]);
    })
    .catch((error) => {
    });
    /*
    FormService.getSubmissionToken(formId)
      .then((response) => {
        const token = response.data;
        //console.log("token", token);
        FormService.listSubmittedFormsSupplier(
          pageNumber,
          perPage,
          searchVal,
          sort,
          formId,
          token
        )
          .then((response) => {
            var totalPages = parseFloat(response.headers["x-total-count"]);
            setItemTotalCount(totalPages);
            setForms([...response.data]);
          })
          .catch((error) => {
          });

      })
      .catch((error) => {
      });
    */
  };
  const handleSort = (val) => {
    if (sortField === val && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setSortField(val);
    getForms(0, itemsPerPage, searchKey, sortField);
  };
  const handleSearch = (key) => {
    setSearchKey(key);
    getForms(0, itemsPerPage, key, sortField);
  };
  const handleForm = (action, formId = "", sId, key) => {
    const formType = "ASSESSMENT";
    const string = Utils.generateUrlParamFormCreate(
      action,
      authToken,
      formType,
      glbRegulationId,
      formId,
      key,
      sId,
      { route: currentRoute, period: reportingPeriod, fid: formId }
    );
    const encodedDat = Utils.encodeBase64(string);
    window.location.href = FORM_BUILDER_LISTING_URL + `/?q=${encodedDat}`;
  };

  const handleNewSubmit = (action, id, externalId, sId) => {
    const formType = "ASSESSMENT";
    var tokenKey = "";
    FormService.getSubmissionToken(id)
      .then((response) => {
        tokenKey = response.data;
        const string = Utils.generateUrlParamFormCreate(
          action,
          authToken,
          formType,
          glbRegulationId,
          externalId,
          tokenKey,
          sId,
          { route: currentRoute, period: reportingPeriod, fid: externalId }
        );
        const encodedDat = Utils.encodeBase64(string);
        window.location.href = FORM_BUILDER_LISTING_URL + `/?q=${encodedDat}`;
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
      });
  };

  const fetchForm = () => {
    if (!searchParams.get('fid')) return;

    FormService.getAssessmentForm(formId).then((res) => {
      if (res.status !== 200) return;

      setFormName(res.data.name);
    })
    .catch((error) => {
    });
  };
  return (
    <>
      <div className="FormsList">
        <div className="List_header">
          <Breadcrumb className="h5">
            <Breadcrumb.Item onClick={() => {
              navigate(`/company_admin/assessments`);
            }} > {t("Assessments.label")}</Breadcrumb.Item>
            <Breadcrumb.Item active>  {formName}</Breadcrumb.Item>
          </Breadcrumb>
        </div>
        {/* <p className="m-0">{regulationName}</p> */}
        <div className="List_Table_01">
          <div className="List_table-card01_head">
            <ul>
              <li>
                <div className="List_table-card_Search_01">
                  <div className="List_table-card_Search_Box">
                    <Form>
                      <input
                        type="text"
                        className="form-control"
                        value={searchKey}
                        onChange={(e) => handleSearch(e.target.value)}
                        placeholder="Search by Name"

                      />
                      <a className="Search_iocnBox cursor" onClick={() => handleSearch(searchKey)}>
                        <BiSearch />
                      </a>
                    </Form>
                  </div>
                </div>
              </li>
              <li>
                <ul className="ps-2">
                  <li>
                    <h6 className="m-0">Reporting Period</h6>
                  </li>
                  <li>
                    <ReportingPeriod valueChangeCallback={(period) => 
                      setReportingPeriod(period.year + '-' + period.month + '-01')
                      } />
                  </li>
                </ul>
              </li>
            </ul>
            <div className="List_table-card01_sort">
              <ul>
                {/* <li className="filter">
                   <Link to="#">
                     <CgSortAz /> {t("Filter.label")}
                   </Link>
                 </li> */}
              </ul>
            </div>
          </div>
          <div className="card List_table-card01">
            <Table responsive="sm">
              <thead>
                <tr>
                  <th className="th_check">
                    <Form.Check
                      inline
                      name="group1"
                      type="checkbox"
                      id="inline-checkbox-1"
                    />
                  </th>
                  <th>{t("SharedOn.label")}</th>
                  <th>{t("Expiry.label")}</th>
                  <th>
                    <Link to="#" onClick={() => handleSort("formStatus")}>
                      {t("Status.label")}
                      <BiSort />
                    </Link>
                  </th>                  
                  <th>
                    <Link to="#" onClick={() => handleSort("lastModifiedDate")}>
                      {t("SubmittedOn.label")}
                      <BiSort />
                    </Link>
                  </th>                  
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {forms.length > 0 ? (
                  forms.map((item, index) => (
                    <tr key={item.submissionId}>
                      <td className="checkbox">
                        {" "}
                        <Form.Check
                          inline
                          name="group1"
                          type="checkbox"
                          id="inline-checkbox-1"
                        />
                      </td>
                      <td>{item.shareDetails?.sharedOn ? moment(item.shareDetails?.sharedOn).format("MMMM DD, YYYY") : ''}</td>
                      <td>
                        {
                          item.shareDetails?.lastSubmissionDate 
                          ? 
                          <>
                            {moment(item.shareDetails?.lastSubmissionDate).format("MMMM DD, YYYY")}&nbsp;
                            {
                              item.status === 'SUBMITTED'  
                              ? <></>
                              :
                              ((Date.now() > moment(item.shareDetails?.lastSubmissionDate).valueOf())
                                ? <Badge bg="badge-Rejected">{t("Expired.label")}</Badge>
                                : <Badge bg="badge-Published">{t("Active.label")}</Badge>)
                              
                            }
                          </>
                          :''
                        }
                      </td>
                      <td>
                        {(() => {
                          switch (item.status) {
                            case "SUBMITTED":
                              return (
                                <Badge bg="badge-Published">
                                  {STATUS[item.status]}
                                </Badge>
                              );
                            default:
                              return (
                                <Badge bg="badge-Draft">
                                  {STATUS[item.status]}
                                </Badge>
                              );
                          }
                        })()}
                      </td>                      
                      <td>
                        {item.submittedOn
                          ? moment(item.submittedOn).format(
                            "MMM DD, YYYY , h:mm:ss a"
                          )
                          : "-"}
                      </td>
                      <td>
                        {item.status === "IN_PROGRESS" ? (
                          <OverlayTrigger
                            placement="top"
                            overlay={Utils.renderTooltip(t("ProceesSubmission.label"))}
                          >
                            <span>
                              <BiSend
                                onClick={() =>
                                  handleForm(
                                    "SUBMIT",
                                    item.form.id,
                                    item.submissionId,
                                    item.token
                                  )
                                }
                              />
                            </span>
                          </OverlayTrigger>
                        ) : (
                          ""
                        )}
                      </td>
                      {/* <td></td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center">
                      <div className="Nodatafound_box">
                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            <div className="p-2 List_footer_count">
              <Pagination
                itemsTotalCount={itemsTotalCount}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                alwaysShown={true}
                setItemsPerPage={setItemsPerPage}
                pageClicked={(pageNum, perPage) => {
                  getForms(pageNum, perPage, searchKey, sortField);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
FormSubmitted.propTypes = {};

export default withTranslation()(FormSubmitted);
